// extracted by mini-css-extract-plugin
export default {"packageCard":"packageCard__MmNmY","preview":"preview__NDQ0Y","fade":"fade__MGRkY","moreButtonContainer":"moreButtonContainer__YzNlZ","moreButton":"moreButton__ODYwN"};